// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectNavbar_container__LedIj","timeslider":"ProjectNavbar_timeslider__1B-96","parametr":"ProjectNavbar_parametr__3QuK5","tab":"ProjectNavbar_tab__1N_qs"};